import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function incomeStatement(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@incomeStatement/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@incomeStatement/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@incomeStatement/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}